var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoGladiusartWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 120,
    viewBox: "0 0 157 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5886 18.6946C16.5886 7.39711 24.8496 0 34.9565 0C43.1653 0 49.3219 4.82785 51.5281 11.5038H43.9876C42.1913 8.47424 39.3191 6.52179 34.9565 6.52179C28.288 6.52179 23.6173 11.4517 23.6173 18.6946C23.6173 25.9375 27.8236 30.8674 34.7504 30.8674C40.8549 30.8674 44.2911 27.5793 44.9072 24.0893H35.8263V17.7195H52.1397V20.3386C52.1397 30.407 44.6512 37.3914 34.7481 37.3914C24.4396 37.3892 16.5886 29.9943 16.5886 18.6946Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M123.496 83.2031L140.837 119.876H133.553L130.628 113.506H116.469L113.647 119.876H106.516L123.496 83.2031ZM127.856 107.549L123.394 97.8431L119.083 107.549H127.856Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9074 49.8125H16.8832V56.8445H23.9074V49.8125Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9074 63.8672H16.8832V70.8992H23.9074V63.8672Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8446 56.8594H0.660294V63.8914H16.8446V56.8594Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M156.974 56.8594H140.787V63.8914H156.974V56.8594Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M140.769 56.8594H23.8914V63.8914H140.769V56.8594Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M140.622 0.0282241V0.0078125H115.964V6.85614H133.788V24.7162H140.629V0.0282241H140.622Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8899 119.975V119.995H41.548V113.147H23.7238V95.2891H16.8831V119.975H16.8899Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGladiusartWhite);
export default __webpack_public_path__ + "static/media/logo-gladiusart-white.724e409208d287e4773a89b7242785fd.svg";
export { ForwardRef as ReactComponent };